import { render } from "./email_modal.vue?vue&type=template&id=4ba1f980&lang=pug"
import script from "./email_modal.vue?vue&type=script&lang=js"
export * from "./email_modal.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__